<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{ $t("placementTypes") }}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="index.html">{{ $t("management") }}</a></li>
              <li class="breadcrumb-item active">{{ $t("placementType_management") }}</li>
            </ol>
          </div>
          <div class="col-sm-6">
            <!-- Bookmark Start-->
            <div class="bookmark">
              <ul>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placementType="top"
                    title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placementType="top"
                    title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placementType="top"
                    title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placementType="top"
                    title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                  <form class="form-inline search-form">
                    <div class="form-group form-control-search">
                      <input type="text" :placeholder="$t('search') + '...'">
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <!-- Bookmark Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-9">
          <div class="card">
            <div class="card-header pb-0">
              <h5 v-if="editMode">{{ $t("edit_placementType") }}</h5>
              <h5 v-else>{{ $t("create_placementType") }}</h5>
            </div>
            <LanguagePicker v-model="selectedLanguage" />
            <div class="card-body">
              <div class="form theme-form">
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>{{ $t("designation") }}*</label>
                      <input class="form-control" type="text" v-model="placementType.names[selectedLanguage]">
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{ $t("profile_connected") }}</label>
                      <div>
                        <input type="checkbox" v-model="placementType.profileConnected">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>{{ $t("app") }}*</label>
                      <v-select class="mt-0 pt-0" v-model="placementType.app" :items="apps" item-text="name"
                        item-value="id" append-icon="" hide-details @change="fetchPlacements(); fetchAppspecificData()">
                        <template slot="item" slot-scope="data">
                          <img style="width:40px;height: 40px;" class="rounded-lg app-icon mr-5"
                            :src="`/files/images/${data.item.icon}`"> {{ data.item.name }}
                        </template>
                        <template class="py-2" slot='selection' slot-scope="data">
                          <img style="width:40px;height: 40px;" class="rounded-lg app-icon my-1 mr-5"
                            :src="`/files/images/${data.item.icon}`"> {{ data.item.name }}
                        </template>
                      </v-select>
                      <!-- <input class="form-control" type="text" v-model="placementType.app"> -->
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{ $t("appspecificdata") }}*</label>
                      <v-select class="mt-0 pt-0" v-model="placementType.appSpecificData" :items="appspecificdata"
                        item-text="name" item-value="id" append-icon="" hide-details>
                        <template slot="item" slot-scope="data">
                          {{ data.item.namesMap[selectedLanguage] }}
                        </template>
                        <template class="py-2" slot='selection' slot-scope="data">
                          {{ data.item.namesMap[selectedLanguage] }}
                        </template>
                      </v-select>
                    </div>
                  </div>

                </div>
                <div class="row">
                  <div class="col py-0">
                    <div class="mb-3">
                      <label>{{ $t("placements") }}*</label>
                      <v-select class="mt-0 pt-0" v-model="placementType.placementIds" :items="placements" multiple
                        item-text="name" item-value="id" append-icon="" hide-details>
                        <template slot="item" slot-scope="data">
                          <img style="width:40px;height: 40px;" class="rounded-lg app-icon mr-5"
                            :src="`/files/images/${data.item.previewImage}`"> {{ data.item.namesMap[$locale] }}
                        </template>
                        <template class="py-2" slot='selection' slot-scope="data">
                          {{ data.item.namesMap[$locale] }}&nbsp;
                        </template>
                      </v-select>
                      <!-- <input class="form-control" type="text" v-model="placementType.type"> -->
                    </div>
                  </div>
                  <div class="col py-0">
                    <div class="mb-3">
                      <label>{{ $t("preview_image") }}*</label>
                      <Upload :label="''" v-model="placementType.previewImage" />
                    </div>
                  </div>
                </div>
                <button style="float: right;" @click="save()" class="btn btn-primary" type="button"
                  data-bs-original-title="" title="">{{ $t("save") }}</button>
                <button class="btn btn-secondary mr-2" style="float: right;" @click="$routerBack()">{{
                  $t("cancel")
                }}</button>
              </div>
            </div>
          </div>

        </div>
        <div class="col-3">
          <div class="card">
            <div class="card-header pb-0">
              <h5>{{ $t("actions") }}</h5>
            </div>
            <div class="card-body" v-if="editMode">
              <button @click="showDeleteConfirmation = true" class="btn btn-danger" type="button"
                data-bs-original-title="" title="">{{ $t("delete_placementType") }}</button>
            </div>
            <div class="card-body" v-else>
              <p>{{ $t("PLACEMENT_SAVE_BEFORE_DELETE_HINT") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Container-fluid Ends-->
    <div class="modal fade show" v-show="showDeleteConfirmation" tabindex="-1" aria-labelledby="exampleModalCenter"
      style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("delete_placementType") }}</h5>
            <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-original-title=""
              title="" @click="(showDeleteConfirmation = false)"></button>
          </div>
          <div class="modal-body">
            <p>{{ $t("confirm_delete_placementType") }}</p>
          </div>
          <div class="modal-footer">
            <button @click="(showDeleteConfirmation = false)" class="btn btn-secondary" type="button"
              data-bs-dismiss="modal" data-bs-original-title="" title="">{{ $t("cancel") }}</button>
            <button @click="deletePlacementType()" class="btn btn-danger" type="button" data-bs-original-title=""
              title="">{{ $t("delete") }}</button>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { MapPinIcon, PlusSquareIcon } from 'vue-feather-icons'

export default {

  props: {
    placementTypeId: Number,
  },

  components: {
    apexcharts: VueApexCharts,
    MapPinIcon,
    PlusSquareIcon,
  },
  data() {
    return {
      editMode: false,

      routes: {
        appspecificdata: "/api/appspecificdata",
        placementTypes: "/api/placementType",
        placements: "/api/placement/app/",
        apps: "/api/app",
        filter: "/api/tenants/search/"
      },

      placementType: {
        app: "",
        names: {},
        previewImage: "",
        placementIds: [],
        appSpecificData: null,
        profileConnected: false,
      },

      selectedLanguage: "en",

      showDeleteConfirmation: false,

      apps: [],
      placements: [],
      appspecificdata: [],

      map: {
        center: {
          latitude: 52.218945,
          longitude: 13.439067
        },
        zoom: 10,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },

      boundaries: [],
    };
  },

  mounted() {
    this.selectedLanguage = this.$locale;
    if (this.placementTypeId != null) {
      this.editMode = true;
      this.fetchEditingPlacementType();
    } else {
      // this.fetchApps();
    }
    this.fetchApps();
  },

  methods: {
    _validate() {

      if (this.placementType.names == null || this.placementType.names[this.selectedLanguage] == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("designation") }));
        return false;
      }
      if (this.placementType.type == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("type") }));
        return false;
      }
      if (this.placementType.app == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("app") }));
        return false;
      }
      if (this.placementType.previewImage == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("preview_image") }));
        return false;
      }

      return true;
    },
    fetchApps(resetPage = false) {
      if (resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get(this.routes.apps)
        .then(function (response) {
          _this.apps = response.data.content;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchAppspecificData() {
      var _this = this;
      this.$axios
        .get(this.routes.appspecificdata + "/app/" + this.placementType.app)
        .then(function (response) {
          _this.appspecificdata = response.data.content;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchPlacements() {
      var _this = this;
      this.$axios
        .get(this.routes.placements + this.placementType.app)
        .then(function (response) {
          _this.placements = response.data.content;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchEditingPlacementType() {
      var _this = this;
      this.$axios
        .get("/api/placementType/" + this.placementTypeId)
        .then(function (response) {
          _this.placementType = response.data;
          _this.placementType.app = response.data.app.id;
          _this.placementType.names = response.data.namesMap;
          var placementIds = [];
          for (let i = 0; i < _this.placementType.placements.length; i++) {
            const placement = _this.placementType.placements[i];
            placementIds.push(placement.id);
          }
          _this.placementType.placementIds = placementIds;
          _this.fetchPlacements();
          _this.fetchAppspecificData();
        })
        .catch(this.onError);
    },
    // fetchApps(search = ""){
    //   if(search == null) return;
    //   var _this = this;
    //   progressIndicator.hidden = false;
    //   this.$axios
    //     .get("/api/app?size=50&search=" + search)
    //     .then(function (response) {
    //       if(_this.tenants.length == 0) _this.tenants = response.data.content;
    //       for (let i = 0; i < response.data.content.length; i++) {
    //         const tenant = response.data.content[i];
    //         if(_this.tenants.filter(t => { return t.name == tenant.name }).length == 0){
    //           _this.tenants.push(tenant);
    //         }
    //       }

    //       if(_this.tenantId != null){
    //         // Remove Tenant which is being edited (no self-adding)
    //         for (let i = _this.tenants.length - 1; i >= 0; i--) {
    //           const tenant = _this.tenants[i];
    //           if(tenant.id == _this.tenantId){
    //             _this.tenants.splice(i, 1);
    //           }
    //         }
    //       }
    //       _this.$forceUpdate();
    //     })
    //     .catch(this.onError)
    //     .finally(this.finalize);
    // },
    save() {
      if (!this._validate()) return;
      var placementType = Object.assign({}, this.placementType);
      placementType.appId = placementType.app.id == undefined ? placementType.app : placementType.app.id;
      delete placementType.app;
      placementType.appSpecificDataId =placementType.appSpecificData == null ? null : placementType.appSpecificData.id == undefined ? placementType.appSpecificData : placementType.appSpecificData.id;
      delete placementType.appSpecificData;
      if (this.editMode) {
        console.log(placementType);
        this.updatePlacementType(placementType);
      } else {
        this.createPlacementType(placementType);
      }
    },
    createPlacementType(placementType) {
      var _this = this;
      this.$axios
        .post("/api/placementType", placementType)
        .then(function (response) {
          _this.$noty.success(_this.$t("placementType_created"));
          _this.$router.push("/placementTypes");
        })
        .catch(this.onError);
    },
    updatePlacementType(placementType) {
      var _this = this;
      this.$axios
        .put("/api/placementType/" + this.placementTypeId, placementType)
        .then(function (response) {
          _this.$noty.success(_this.$t("placementType_updated"));
          _this.$router.push("/placementTypes");
        })
        .catch(this.onError);
    },
    deletePlacementType() {
      var _this = this;
      this.$axios
        .delete("/api/placementType/" + this.placementTypeId)
        .then(function (response) {
          _this.showDeleteConfirmation = false;
          _this.$noty.success(_this.$t("placementType_deleted"));
          _this.$router.push("/placementTypes");
        })
        .catch(this.onError);
    },
    logError(error) {
      console.log(error);
    },
    onError(error) {
      console.log(error);
    },
    finalize() {
      progressIndicator.hidden = true;
    }
  },
};
</script>

<style>

</style>